import React, { useState, useEffect } from "react";

import "../styles/dark.css"
import "../styles/light.css"
import "../styles/global.css"; 

const EbookletThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState("dark"); // Default theme

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const themeFromURL = urlParams.get("theme");
    const savedTheme = localStorage.getItem("theme");

    let appliedTheme = "dark"; // Default

    if (themeFromURL === "dark") {
      appliedTheme = "dark";
      localStorage.setItem("theme", "dark");
    } else if (themeFromURL === "light") {
      appliedTheme = "light";
      localStorage.setItem("theme", "light");
    } else if (savedTheme) {
      appliedTheme = savedTheme;
    }

    localStorage.setItem("theme", appliedTheme)
    document.documentElement.className = appliedTheme; // Apply the theme class
    setTheme(appliedTheme);
  }, []); // Runs only once on mount

  useEffect(() => {
    document.documentElement.className = theme; // Apply the theme class
  }, [theme]); // Runs when `theme` changes

  return <>{children}</>;
};

export default EbookletThemeProvider;
